import { createTheme, ThemeProvider } from '@mui/material/styles';
import { tokens } from './tokens';

/** Light island theme for the floating login card on the dark shell. */
export const loginCardTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: tokens.primary,
      dark: tokens.primaryDark,
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: tokens.brandFill,
      dark: tokens.brandInk,
      contrastText: '#FFFFFF',
    },
    background: {
      default: tokens.cardLight,
      paper: tokens.cardLight,
    },
    text: {
      primary: tokens.cardLightInk,
      secondary: tokens.cardLightMuted,
    },
    divider: '#E2E2E2',
  },
  typography: {
    fontFamily: '"Plus Jakarta Sans", system-ui, sans-serif',
    h4: { fontFamily: '"Fraunces", Georgia, serif', fontWeight: 650 },
    button: { textTransform: 'none', fontWeight: 600 },
  },
  shape: { borderRadius: 12 },
  components: {
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: {
        root: {
          fontWeight: 600,
        },
        containedSecondary: {
          backgroundColor: tokens.brandFill,
          color: '#FFFFFF',
          '&:hover': {
            backgroundColor: tokens.brandInk,
            color: '#FFFFFF',
          },
        },
        containedPrimary: {
          backgroundColor: tokens.primary,
          color: '#FFFFFF',
          '&:hover': {
            backgroundColor: tokens.primaryDark,
            color: '#FFFFFF',
          },
        },
      },
    },
  },
});

export function LoginCardTheme({ children }) {
  return <ThemeProvider theme={loginCardTheme}>{children}</ThemeProvider>;
}
